import { observer } from 'mobx-react';
import React, { Component } from 'react';
import Gene from 'stores/models/Gene';

interface IProps {
  gene: Gene;
}

class View extends Component<IProps> {
  render() {
    const { info, state } = this.props.gene;

    return (
      <React.Fragment>
        <span>{info.qualifier}</span>
        <sup>{state.superscript}</sup>
      </React.Fragment>
    );
  }
}

const GeneExpression = observer(View);
export default GeneExpression;
